import React from "react";
import { connect } from "react-redux";
import { setGlobalValue } from "../redux-actions/global-actions";
import { setMatchmakingValue } from "../redux-actions/battle-actions";
import BattleResultProcessingLoader from "./BattleResultProcessingLoader";
import UserCrewRecord from "./UserCrewRecord";
import NewlyUnlockedList from "./NewlyUnlockedList";

/* eslint jsx-a11y/href-no-hash: "off" */

class BattleOverScreen extends React.Component {
  constructor() {
    super();
    this.state = {
      newUnlockIds: [],
      isResultsProcessingDone: false //This process needs to complete before we show anything. If not done, show a loader
    };
  }

  handleDoneProcessingResults() {
    this.setState({
      isResultsProcessingDone: true
    });
    //Now you're safe to pull needed values from redux state.
  }

  //The Processing component has sent up our new unlocks
  handleReceiveNewUnlocks(newUnlocks) {
    this.setState({
      newUnlockIds: newUnlocks
    });
  }

  handleNewOfflineBattle(e) {
    e.preventDefault();
    //Simply reseting the gameArea to "battle" will remount the battle components and everything will be cool
    //If you need to do any "make the next battle state different" kind of stuff, do that before setting gameArea!

    //Reset the winner
    setMatchmakingValue({
      matchResult: "unknown"
    });

    //Transition back to battle
    setGlobalValue({
      gameArea: "battle"
    });
  }

  /* Generate the href for the next battle link */
  getNextBattleLink() {
    //NOTE: Make sure "&open" is in the URL here. This way, our Next Battle will also be Open
    if (this.props.currentRoomType === "open") {
      return `/?online=y&open=y&p=${this.props.currentRoomId || "unknown"}+1`;
    }

    //NOTE: This might need to change if URLs get prettier
    return `/?online=y&p=${this.props.currentRoomId || "unknown"}+1`;
  }

  //Maybe return styles that wrap the desktop layout together
  getDesktopWrap() {
    if (this.props.viewportMode === "portrait") {
      return {};
    }
    return {
      width: "40em",
      margin: "0 auto"
    };
  }

  renderHeadlineResult() {
    let text = "unknown";
    if (this.props.matchResult === "win") {
      text = "Victory!";
    }
    if (this.props.matchResult === "lose") {
      text = "Defeat!";
    }

    const style = {
      fontSize: "2.3em",
      marginBottom: "1em",
      textAlign: "center"
    };
    return (
      <div style={style}>
        {text}
      </div>
    );
  }

  renderMainContent() {
    const { mode } = this.props;
    const crewRecordContainerStyle = {
      marginBottom: "3em"
    };

    return (
      <div>
        {this.renderHeadlineResult()}
        <NewlyUnlockedList newlyUnlockedIds={this.state.newUnlockIds} />
        <div style={crewRecordContainerStyle}>
          <UserCrewRecord />
        </div>
        {mode === "online"
          ? <div>
              <a
                className="button block large primary"
                href={this.getNextBattleLink()}
              >
                Join Next Battle!
              </a>
              <a className="button block large" href="/">
                Back to Home Screen
              </a>
            </div>
          : <div>
              <a
                className="button block large primary"
                href="#"
                onClick={this.handleNewOfflineBattle.bind(this)}
              >
                <span className="button--text">Battle Again!</span>
              </a>
              <a className="button block large" href="/">
                <span className="button--text">Back to Home Screen</span>
              </a>
            </div>}
      </div>
    );
  }

  renderLoadingSequence() {
    return (
      <div>
        <BattleResultProcessingLoader
          onDone={this.handleDoneProcessingResults.bind(this)}
          provideNewUnlocks={this.handleReceiveNewUnlocks.bind(this)}
        />
      </div>
    );
  }

  render() {
    const style = {
      fontSize: this.props.viewportMode === "portrait" ? "0.6em" : "0.5em", //mobile, desktop
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-around"
    };

    //Uses `mode` prop for online button options vs offline button options
    return (
      <div style={{ height: "100%" }}>
        <div style={style} className="menu-texture">
          <div style={{ padding: "1em", ...this.getDesktopWrap() }}>
            <div className="menu-card">
              {this.state.isResultsProcessingDone
                ? this.renderMainContent()
                : this.renderLoadingSequence()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state, props) => {
  return {
    vW: state.global.vW,
    viewportMode: state.global.viewportMode,
    currentRoomId: state.matchmaking.currentRoomId,
    currentRoomType: state.matchmaking.currentRoomType,

    matchResult: state.matchmaking.matchResult
  };
})(BattleOverScreen);



// WEBPACK FOOTER //
// ./src/battle/BattleOverScreen.js